module.exports = self["html2canvas"];